import React, { useEffect, useState } from "react";

interface SwitchProps {
  enabled: boolean;
  onChange: (isEnabled: boolean) => void;
}
function SwitchButton({ enabled, onChange }: SwitchProps) {
  const [isChecked, setIsChecked] = useState(enabled);

  const toggleSwitch = () => {
    const newIsChecked = !isChecked;
    setIsChecked(newIsChecked);
    onChange(newIsChecked);
  };

  useEffect(() => {
    setIsChecked(enabled);
  }, [enabled]);
  return (
    <div className="flex items-center relative">
      <div
        className={`w-10 h-4 rounded-full ${
          isChecked ? "bg-primary-light" : "bg-gray-2"
        }`}
      >
        <button
          className={` absolute -top-[2px] duration-300 w-6 h-6 rounded-full bg-primary-main ${
            isChecked && "transform translate-x-[20px] "
          }`}
          onClick={toggleSwitch}
        />
      </div>
    </div>
  );
}
export default SwitchButton;
